//@ts-nocheck
export const shortConversion = (utm: { value: number, check: boolean }, short_id, pixelShortConversion) => {
  try {
    console.log('Event shortConversion -> ', utm.check, short_id)
    if (utm.check) {
      window.gtag('event', 'conversion', {
        send_to: short_id,
        value: utm.value,
        currency: 'EUR'
      });
      if (pixelShortConversion) {
        console.log('pixelTag--> ', pixelShortConversion)
        window.dataLayer.push({
          conversion_name: pixelShortConversion
        })
      }
      window.uetq = window.uetq || [];
      window.uetq.push('event', 'short_lead', { 'event_category': 'lead', 'event_label': 'conversion_short' });

    }
  } catch (error) {
    console.log(error)
  }
}

export const largeConversion = (utm: { value: number, check: boolean }, large_id, pixelLargeConversion) => {
  try {
    console.log('Event largeConvercion -> ', utm.check, large_id)
    if (utm.check) {
      window.gtag('event', 'conversion', {
        send_to: large_id,
        value: utm.value,
        currency: 'EUR'
      });
      if (pixelLargeConversion) {
        console.log('pixelTag--> ', pixelLargeConversion)
        window.dataLayer.push({
          conversion_name: pixelLargeConversion
        })
      }
      window.uetq = window.uetq || [];
      window.uetq.push('event', 'large_lead', { 'event_category': 'lead', 'event_label': 'conversion_large' });
      window.dataLayer.push({
        event: "gtm.dom",
      })
    }
  } catch (error) {
    console.log(error)
  }
}